<template>
<div id="svgperf">
    <div class="modal is-active " :class="{'animated fadeOutUp faster': loaded}">
        <div class="modal-background hero is-primary is-bold"></div>
        <div class="modal-content">
            <div class="container has-text-centered">
                <div  class="image" style="min-height:120px;">
                    <svg v-if="logoImage" width="120" viewBox="0 0 60 60">
                        <image
                            ref="logo"
                            v-if="logoImage"
                            :href="logoImage"
                            width="60"
                            height="60"
                        />
                    </svg>
                </div>
                <div class="button is-loading is-text"></div>
                <div style="width:200px; margin: auto auto; padding-bottom:20px;">
                    <b-progress
                        type="is-info"
                        size="is-small"
                        :value="progress ? progress : undefined"
                        :max="3"
                    /> 
                </div>
                <div class="has-text-white">
                    <p>Generating Report</p>
                    <p class="help">This might take some times</p>
                </div>
            </div>
        </div>
    </div>
    <svg-graph 
        width="100%"
        height="100%"
        v-if="loaded"
        :logoImage="logoImage"
        :topClasses="topClasses"
        :topTeachers="topTeachers"
        :topStudents="topStudents"
        :reportMonth="reportMonth"
        :reportData="reportData"
        :school="school"
        :totalPoints="totalPoints"
        :totalScans="totalScans"
        :behaviours="behaviours"
    />
</div>
</template>

<script>
import 'animate.css'
import axios from 'axios'
import SvgGraph from './SvgGraph'
import imageEncode from '@/services/imageEncode'

export default {
    components:{
        SvgGraph
    },
    data(){
        return {
            logoImage: '',  
            loaded: false, 
        }
    },
    computed:{
        behaviours(){
            return this.$store.getters.behaviours
        },
        topClasses(){
            return this.$store.getters.topClasses;
        },
        topTeachers(){
            return this.$store.getters.topTeachers;
        },
        topStudents(){
            return this.$store.getters.topStudents;
        },
        reportMonth(){
            return this.$store.state.reportMonth.toUpperCase()
        },
        reportData(){
            return {
                schoolID: '5c39e5dc7225c90d881089c7',
                year: "2020",
                month: "05",    
                ...this.$route.params,
            }
        },
        school(){
            return this.$store.state.schoolPerformance.school || {}
        },
        totalPoints(){
            return this.$store.getters.totalPoints
        },
        totalScans(){
            return this.$store.getters.totalScans
        },
        progress(){
            return this.$store.state.progress
        }
    },
    watch:{
        reportData(){
            this.loadData()
        }
    },
    mounted(){
        this.loadData().catch(() => {
            this.$router.replace('/')
        })
    },
    methods:{
        loadData(){
            this.loaded = false
            this.loadLogo().then(() => {
                // this.loaded = true
            })
            return this.$store.dispatch("load", this.reportData).then(() => {
                this.loaded = true
            })
        },
        loadLogo(){
            return axios.get(`https://api.studentqr.com/public/logo?schoolID=${this.reportData.schoolID}`,{
                responseType: 'arraybuffer' 
            }).then(res => {
                this.logoImage  = imageEncode(res.data)
            })
        },  
    },
    filters:{
        toLocale(v){
            if(!parseInt(v)){
                return v
            }

            return parseInt(v).toLocaleString()
        }
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Poppins:400,700&display=swap');

#svgperf {
  width: 100vw;
  height: 98vh;
  background: #fff;
}

.progress::-webkit-progress-value {
  transition: width 0.5s ease;
}
</style>
